function parseDateStr(dateStr: string): [number, number, number] {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
		throw new Error(`Invalid date string: "${dateStr}"`);
	}
	const parts = dateStr.split('-').map(Number);
	const y = parts[0]!;
	const m = parts[1]!;
	const d = parts[2]!;
	if (!isFinite(y) || !isFinite(m) || !isFinite(d)) {
		throw new Error(`Invalid date components in: "${dateStr}"`);
	}
	return [y, m, d];
}

export function isValidDateStr(dateStr: string): boolean {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
		return false;
	}
	const parts = dateStr.split('-').map(Number);
	const y = parts[0]!;
	const m = parts[1]!;
	const d = parts[2]!;
	const date = new Date(y, m - 1, d);
	return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}

export function toLocalStartIso(dateStr: string): string {
	const [y, m, d] = parseDateStr(dateStr);
	return new Date(Date.UTC(y, m - 1, d, 0, 0, 0)).toISOString();
}

export function toLocalEndIso(dateStr: string): string {
	const [y, m, d] = parseDateStr(dateStr);
	return new Date(Date.UTC(y, m - 1, d, 23, 59, 59, 999)).toISOString();
}

/** Current local time formatted for an `<input type="datetime-local">` value. */
export function nowDatetimeLocal(): string {
	const d = new Date();
	const local = new Date(d.getTime() - d.getTimezoneOffset() * 60_000);
	return local.toISOString().slice(0, 16);
}

/** Converts a `datetime-local` input value to a UTC ISO string. Throws if `s` is empty or not a valid date. */
export function datetimeLocalToUtcIso(s: string): string {
	if (!s) {
		throw new Error('Date/time is required');
	}
	const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(s);
	if (!match) {
		throw new Error(`Invalid date/time: "${s}"`);
	}
	const date = new Date(s);
	if (
		isNaN(date.getTime()) ||
		date.getFullYear() !== Number(match[1]) ||
		date.getMonth() !== Number(match[2]) - 1 ||
		date.getDate() !== Number(match[3]) ||
		date.getHours() !== Number(match[4]) ||
		date.getMinutes() !== Number(match[5])
	) {
		throw new Error(`Invalid date/time: "${s}"`);
	}
	return date.toISOString();
}
